// extracted by mini-css-extract-plugin
export default {"main":"b4026c2f8b","tit":"_2298ada633","maintitle":"_3357c2bd69","ylw":"cb684c51bc","white":"_604988695d","mv_title":"_6e7a88d96d","mv_nc":"_0a044cb400","mv_in":"_254cbcec3b"};